var _path, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1924 7.99623C15.1924 11.8531 11.5751 15.1932 10.1564 16.3549C9.82582 16.6256 9.36439 16.6256 9.03379 16.3549C7.61509 15.1932 3.9978 11.8531 3.9978 7.99623C3.9978 4.90492 6.5038 2.39893 9.59511 2.39893C12.6864 2.39893 15.1924 4.90492 15.1924 7.99623Z",
    stroke: "#596475",
    strokeWidth: 1.72717
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.59538,
    cy: 7.99601,
    rx: 2.39884,
    ry: 2.39884,
    stroke: "#596475",
    strokeWidth: 1.72717
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGrey);
export default __webpack_public_path__ + "static/media/location_grey.2e105382fba84d1fa16f246f3bfb2e7d.svg";
export { ForwardRef as ReactComponent };